import React from 'react'
import {
    Route,
    Switch,
    Redirect,
    withRouter
} from 'react-router-dom'
import { connect } from "react-redux";

import * as constants from 'Data/constants'
import SideDrawer from "components/Navigation/SideDrawer/SideDrawer"
import Toolbar from "components/Navigation/Toolbar/Toolbar"
import License from 'components/License/License'
import Logout from "containers/Login/Logout"
import ErrorPage from "containers/ErrorPage"
import { isMobile } from 'containers/utils'
import routes from '../urls'

export const PrivateRoute = (privateRouteProps) => {

    const {
        hasPermission,
        feature,
        render,
        ...props
    } = privateRouteProps

    return hasPermission ? (
        <Route
            render={compProps => (
                <License feature={feature}>
                    {render(compProps)}
                </License>
            )}
            {...props}
        />
    ) : <Redirect to={`/dashboard${props.history ? props.history.location.search : ''}`} />
}

const AuthIndexRoute = ({ history }) => (
    // The substring removes "/org" from pathname , 
    // because we have /org as basename, and if not removed, we will have /org/org<some-path>
    history.location && history.location.state
        ? <Redirect to={history.location.state.substring(4)} />
        : <Redirect to={`/dashboard${history.location.search}`} />
)

class ModularRoutes extends React.Component {

    state = {
        sidenavopen: !isMobile(),
        shepherdTourData: {},
        showTourButton: false,
    }

    shouldComponentUpdate(prevProps, prevState) {
        if (prevProps.location.pathname !== this.props.location.pathname
            || prevState.sidenavopen !== this.state.sidenavopen
            || this.props.location.search !== prevProps.location.search
            || prevState.shepherdTourData !== this.state.shepherdTourData
            || prevState.showTourButton !== this.state.showTourButton
        )
            return true
        return false
    }

    handleSidebarOpenClose = (isOpenState = null) => {
        this.setState(prevState => ({
            sidenavopen: isOpenState !== null ? isOpenState : !prevState.sidenavopen
        }))
    }

    updateShepherdTourData = (steps, tourOptions, autoStart = false) => {
        if (!isMobile()) {
            if (steps && tourOptions) {
                let shepherdTourData = {
                    steps,
                    tourOptions,
                    autoStart
                }
                this.setState({
                    shepherdTourData
                })
            } else {
                this.setState({
                    shepherdTourData: {}
                })
            }
        }
    }

    showTourButtonHandler = (showTourButton) => {
        this.setState({
            showTourButton
        })
    }

    handleOkaygoRedirect = () => {
        const processKey = this.processData?.process_key ? this.processData?.process_key : ""
        if (processKey)
            this.props.history.push(`/process_okaygo?process_key=${processKey}`)
        else
            this.props.history.push(`/process_okaygo`)
    }

    render() {
        const { user, history } = this.props
        const uiFeatures = user.uiFeatures
        const showDrawer = (!history.location.pathname.includes("tasks") && !history.location.pathname.includes("start-new-process")) && !history.location.pathname.includes("import-history");
        const showTaskPageBtn = !history.location.search.includes("task-app") && !history.location.search.includes("start-new-process") && !history.location.pathname.includes("worker_view");
        const workerView = !history.location.pathname.includes("worker_view");
        return (
            <>
                <Switch>
                    <PrivateRoute
                        exact
                        hasPermission={user.uiPermissions.organisationuser.view}
                        feature={user.uiFeatures.organisationuser.view}
                        path={routes.WORKER_VIEW.path}
                        history={history}
                        render={(props) => (<routes.WORKER_VIEW.component {...props} />)}
                    />
                </Switch>
                {showDrawer && <Toolbar
                    clicked={this.handleSidebarOpenClose}
                    hamburger={showDrawer ? this.state.sidenavopen : false}
                    shepherdTourData={this.state.shepherdTourData}
                    showTourButton={this.state.showTourButton}
                />}
                {showTaskPageBtn && <button onClick={this.handleOkaygoRedirect} className='goToOkaygo'>
                    Task page
                </button>}
                <div className="main_container">
                    <div className={this.state.sidenavopen && showDrawer ? "body_container active" : "body_container"}>
                        {showDrawer && workerView && <div id="lef_side">
                            <SideDrawer
                                open={this.state.sidenavopen}
                                onItemClickHandler={this.handleSidebarOpenClose}
                            />
                        </div>}
                        {workerView && <div id="right_side" role="presentation" onClick={() => (isMobile() && this.state.sidenavopen ? this.handleSidebarOpenClose() : null)}>
                            <main>
                                <Switch>
                                    <AuthIndexRoute
                                        exact
                                        path="/"
                                        user={user}
                                        history={history}
                                    />
                                    <AuthIndexRoute
                                        exact
                                        path="/login"
                                        user={user}
                                        history={history}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission
                                        path="/logout"
                                        component={(props) => (<Logout {...props} />)}
                                    />
                                    <Route
                                        exact
                                        history={history}
                                        path={routes.START_NEW_PROCESS.path}
                                        render={props => <routes.START_NEW_PROCESS.component {...props} />}
                                    />
                                    <PrivateRoute
                                        exact
                                        path={routes.APP.path}
                                        hasPermission={user.uiPermissions.organisationworkflow.view}
                                        feature={uiFeatures.organisationworkflow.view}
                                        history={history}
                                        render={(props) => (<routes.APP.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        path={routes.APP_ADD.path}
                                        hasPermission={user.uiPermissions.organisationworkflow.add}
                                        feature={uiFeatures.organisationworkflow.view}
                                        history={history}
                                        render={(props) => (<routes.APP_ADD.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationworkflow.change}
                                        feature={uiFeatures.organisationworkflow.change}
                                        path={routes.APP_CONFIGURE.path}
                                        history={history}
                                        render={(props) => (<routes.APP_CONFIGURE.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.processes.manage}
                                        feature
                                        path={routes.PROCESS.path}
                                        history={history}
                                        render={(props) => (<routes.PROCESS.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.processes.manage}
                                        feature
                                        path={routes.PROCESS_OKAYGO.path}
                                        history={history}
                                        render={(props) => (<routes.PROCESS_OKAYGO.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.tasks.manage}
                                        feature
                                        path={routes.TASKS.path}
                                        history={history}
                                        render={(props) => (<routes.TASKS.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        path={routes.TASK_DETAILS.path}
                                        hasPermission={user.uiPermissions.tasks.manage}
                                        feature
                                        history={history}
                                        render={(props) => (<routes.TASK_DETAILS.component {...props} handleSidebarOpenClose={this.handleSidebarOpenClose} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationuser.view}
                                        feature={user.uiFeatures.organisationuser.view}
                                        path={routes.USERS.path}
                                        history={history}
                                        render={(props) => (<routes.USERS.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationuser.add}
                                        feature
                                        path={routes.USER_CREATE.path}
                                        history={history}
                                        render={(props) => (<routes.USER_CREATE.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        path={routes.USER_EDIT.path}
                                        hasPermission={user.uiPermissions.organisationuser.change}
                                        feature
                                        history={history}
                                        render={(props) => (<routes.USER_EDIT.component {...props} />)}
                                    />
                                    <Route
                                        exact
                                        path={routes.DASHBOARD.path}
                                        user={user}
                                        history={history}
                                        render={(props) => (<routes.DASHBOARD.component {...props} updateShepherdTourData={this.updateShepherdTourData} showTourButtonHandler={this.showTourButtonHandler} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.location.view}
                                        feature={uiFeatures.location.view}
                                        path={routes.LOCATION_LIST.path}
                                        history={history}
                                        render={(props) => (<routes.LOCATION_LIST.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.location.add}
                                        feature={uiFeatures.location.add}
                                        path={routes.LOCATION_CREATE.path}
                                        history={history}
                                        render={(props) => (<routes.LOCATION_CREATE.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.location.change}
                                        feature={uiFeatures.location.change}
                                        path={routes.LOCATION_EDIT.path}
                                        history={history}
                                        render={(props) => (<routes.LOCATION_EDIT.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationgroup.view}
                                        feature={uiFeatures.organisationgroup.view}
                                        path={routes.GROUP_LIST.path}
                                        history={history}
                                        render={(props) => (<routes.GROUP_LIST.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationgroup.add}
                                        feature={uiFeatures.organisationgroup.add}
                                        path={routes.GROUP_CREATE.path}
                                        history={history}
                                        render={(props) => (<routes.GROUP_CREATE.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationgroup.change}
                                        feature={uiFeatures.organisationgroup.change}
                                        path={routes.GROUP_EDIT.path}
                                        history={history}
                                        render={(props) => (<routes.GROUP_EDIT.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.department.view}
                                        feature={uiFeatures.department.view}
                                        path={routes.DEPARTMENT_LIST.path}
                                        history={history}
                                        render={(props) => (<routes.DEPARTMENT_LIST.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.department.add}
                                        feature={uiFeatures.department.add}
                                        path={routes.DEPARTMENT_CREATE.path}
                                        history={history}
                                        render={(props) => (<routes.DEPARTMENT_CREATE.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.portals.view}
                                        feature={uiFeatures.portals.view}
                                        path={routes.PORTALS.path}
                                        history={history}
                                        render={(props) => (<routes.PORTALS.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.portals.view}
                                        feature={uiFeatures.portals.view}
                                        path={routes.PORTAL_CREATE.path}
                                        history={history}
                                        render={(props) => (<routes.PORTAL_CREATE.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.portals.view}
                                        feature={uiFeatures.portals.view}
                                        path={routes.CONTENTS_ID.path}
                                        history={history}
                                        render={(props) => (<routes.CONTENTS_ID.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.portals.view}
                                        feature={uiFeatures.portals.view}
                                        path={routes.CONTENTS.path}
                                        history={history}
                                        render={(props) => (<routes.CONTENTS.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.smtpsettings.view}
                                        feature={uiFeatures.smtpsettings.view}
                                        path={routes.SMTP_CREATE.path}
                                        history={history}
                                        render={(props) => (<routes.SMTP_CREATE.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.department.change}
                                        feature={uiFeatures.department.change}
                                        path={routes.DEPARTMENT_EDIT.path}
                                        history={history}
                                        render={(props) => (<routes.DEPARTMENT_EDIT.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisation.view && uiFeatures.organisationlicense.theme}
                                        feature={uiFeatures.organisationlicense.theme}
                                        path={routes.THEMES.path}
                                        history={history}
                                        render={(props) => (<routes.THEMES.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission
                                        feature
                                        path={routes.PROFILE.path}
                                        history={history}
                                        render={(props) => (<routes.PROFILE.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.groupName === constants.OWNER || user.groupName === constants.SUPER_ADMINISTRATOR}
                                        feature
                                        path={routes.MANAGEACCOUNT.path}
                                        history={history}
                                        render={(props) => (<routes.MANAGEACCOUNT.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        path={routes.CONFIG_VIEW.path}
                                        hasPermission={user.groupName === 'Owner' || user.groupName === 'Super Administrator'}
                                        feature={uiFeatures.organisationworkflow.view}
                                        history={history}
                                        render={(props) => (<routes.CONFIG_VIEW.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.reporttemplate.view}
                                        feature
                                        path={routes.REPORT.path}
                                        history={history}
                                        render={(props) => (<routes.REPORT.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.reporttemplate.view}
                                        feature
                                        path={routes.REPORT_CREATE.path}
                                        history={history}
                                        render={(props) => (<routes.REPORT_CREATE.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.reporttemplate.view}
                                        feature
                                        path={routes.REPORT_EDIT.path}
                                        history={history}
                                        render={(props) => (<routes.REPORT_EDIT.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.reporttemplate.view}
                                        feature
                                        path={routes.REPORT_SCHEDULE.path}
                                        history={history}
                                        render={(props) => (<routes.REPORT_SCHEDULE.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission
                                        feature
                                        path={routes.FORM_BUILDER.path}
                                        render={(props) => (<routes.FORM_BUILDER.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission
                                        feature
                                        path={routes.FORM_PREVIEW.path}
                                        render={(props) => (<routes.FORM_PREVIEW.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission
                                        feature
                                        path={routes.FORM_EDIT.path}
                                        render={(props) => (<routes.FORM_EDIT.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationasset.view}
                                        feature={uiFeatures.organisationasset.view}
                                        path={routes.ASSET_LIST.path}
                                        history={history}
                                        render={(props) => (<routes.ASSET_LIST.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationasset.add}
                                        feature={uiFeatures.organisationasset.add}
                                        path={routes.ASSET_CREATE.path}
                                        history={history}
                                        render={(props) => (<routes.ASSET_CREATE.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationasset.change}
                                        feature={uiFeatures.organisationasset.change}
                                        path={routes.ASSET_EDIT.path}
                                        history={history}
                                        render={(props) => (<routes.ASSET_EDIT.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationkit.view}
                                        feature={uiFeatures.organisationkit.view}
                                        path={routes.KIT_LIST.path}
                                        history={history}
                                        render={(props) => (<routes.KIT_LIST.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationkit.add}
                                        feature={uiFeatures.organisationkit.add}
                                        path={routes.KIT_CREATE.path}
                                        history={history}
                                        render={(props) => (<routes.KIT_CREATE.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationkit.change}
                                        feature={uiFeatures.organisationkit.change}
                                        path={routes.KIT_EDIT.path}
                                        history={history}
                                        render={(props) => (<routes.KIT_EDIT.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationassetdistribution.view}
                                        feature={uiFeatures.organisationassetdistribution.view}
                                        path={routes.DISTRIBUTION_LIST.path}
                                        history={history}
                                        render={(props) => (<routes.DISTRIBUTION_LIST.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationassetdistribution.add}
                                        feature={uiFeatures.organisationassetdistribution.add}
                                        path={routes.DISTRIBUTION_CREATE.path}
                                        history={history}
                                        render={(props) => (<routes.DISTRIBUTION_CREATE.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationassetdistribution.view}
                                        feature={uiFeatures.organisationassetdistribution.view}
                                        path={routes.DISTRIBUTION_INTER_TRANSFER_LIST.path}
                                        history={history}
                                        render={(props) => (<routes.DISTRIBUTION_INTER_TRANSFER_LIST.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationassetdistribution.view}
                                        feature={uiFeatures.organisationassetdistribution.view}
                                        path={routes.DISTRIBUTION_OTHER_TRANSFER_LIST.path}
                                        history={history}
                                        render={(props) => (<routes.DISTRIBUTION_OTHER_TRANSFER_LIST.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationassetdistribution.add}
                                        feature={uiFeatures.organisationassetdistribution.add}
                                        path={routes.DISTRIBUTION_INTER_TRANSFER_CREATE.path}
                                        history={history}
                                        render={(props) => (<routes.DISTRIBUTION_INTER_TRANSFER_CREATE.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationstocks.view}
                                        feature={uiFeatures.organisationstocks.view}
                                        path={routes.STOCK_LIST.path}
                                        history={history}
                                        render={(props) => (<routes.STOCK_LIST.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationstocks.change}
                                        feature={uiFeatures.organisationstocks.change}
                                        path={routes.STOCK_ADJUST.path}
                                        history={history}
                                        render={(props) => (<routes.STOCK_ADJUST.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationstocks.change}
                                        feature={uiFeatures.organisationstocks.change}
                                        path={routes.STOCK_THRESHOLD.path}
                                        history={history}
                                        render={(props) => (<routes.STOCK_THRESHOLD.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationstocks.view}
                                        feature={uiFeatures.organisationstocks.view}
                                        path={routes.STOCK_ADJUST_LIST.path}
                                        history={history}
                                        render={(props) => (<routes.STOCK_ADJUST_LIST.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationsupplier.view}
                                        feature={uiFeatures.organisationsupplier.view}
                                        path={routes.SUPPLIER_LIST.path}
                                        history={history}
                                        render={(props) => (<routes.SUPPLIER_LIST.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationsupplier.add}
                                        feature={uiFeatures.organisationsupplier.add}
                                        path={routes.SUPPLIER_CREATE.path}
                                        history={history}
                                        render={(props) => (<routes.SUPPLIER_CREATE.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationsupplier.change}
                                        feature={uiFeatures.organisationsupplier.change}
                                        path={routes.SUPPLIER_EDIT.path}
                                        history={history}
                                        render={(props) => (<routes.SUPPLIER_EDIT.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationsupply.view}
                                        feature={uiFeatures.organisationsupply.view}
                                        path={routes.SUPPLY_LIST.path}
                                        history={history}
                                        render={(props) => (<routes.SUPPLY_LIST.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationsupply.add}
                                        feature={uiFeatures.organisationsupply.add}
                                        path={routes.SUPPLY_CREATE.path}
                                        history={history}
                                        render={(props) => (<routes.SUPPLY_CREATE.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.organisationsupply.change}
                                        feature={uiFeatures.organisationsupply.change}
                                        path={routes.SUPPLY_EDIT.path}
                                        history={history}
                                        render={(props) => (<routes.SUPPLY_EDIT.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        hasPermission
                                        feature={uiFeatures.organisationlicense.master}
                                        path={routes.MASTER.path}
                                        render={(props) => (<routes.MASTER.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        hasPermission={user.uiPermissions.organisationlists.view}
                                        feature={uiFeatures.organisationlists.view}
                                        path={routes.CUSTOM_DATA.path}
                                        render={(props) => (<routes.CUSTOM_DATA.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission
                                        feature
                                        path={routes.LOCATION_HISTORY.path}
                                        render={(props) => (
                                            <routes.LOCATION_HISTORY.component
                                                {...props}
                                                entity={routes.LOCATION_HISTORY.entity}
                                                breadCrumb={routes.LOCATION_HISTORY.breadCrumb}
                                            />
                                        )}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission
                                        feature
                                        path={routes.USER_HISTORY.path}
                                        render={(props) => (
                                            <routes.USER_HISTORY.component
                                                {...props}
                                                entity={routes.USER_HISTORY.entity}
                                                breadCrumb={routes.USER_HISTORY.breadCrumb}
                                            />
                                        )}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission
                                        feature={uiFeatures.organisationlicense.bulkprocess}
                                        path={routes.BULK_INITIATE_HISTORY.path}
                                        render={(props) => (
                                            <routes.BULK_INITIATE_HISTORY.component
                                                {...props}
                                                entity={routes.BULK_INITIATE_HISTORY.entity}
                                                breadCrumb={routes.BULK_INITIATE_HISTORY.breadCrumb}
                                            />
                                        )}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission
                                        feature
                                        history={history}
                                        path={routes.ENTITY_LIST.path}
                                        render={(props) => (<routes.ENTITY_LIST.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission
                                        feature
                                        history={history}
                                        path={routes.ENTITY_DETAILS.path}
                                        render={(props) => (<routes.ENTITY_DETAILS.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.group.view}
                                        feature={uiFeatures.group.view}
                                        path={routes.CUSTOM_ROLE.path}
                                        render={(props) => (<routes.CUSTOM_ROLE.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.customattribute.view}
                                        feature={uiFeatures.customattribute.view}
                                        path={routes.CUSTOM_ATTRIBUTES.path}
                                        render={(props) => (<routes.CUSTOM_ATTRIBUTES.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission
                                        feature
                                        path={routes.GROUP_HISTORY.path}
                                        render={(props) => (
                                            <routes.GROUP_HISTORY.component
                                                {...props}
                                                entity={routes.GROUP_HISTORY.entity}
                                                breadCrumb={routes.GROUP_HISTORY.breadCrumb}
                                            />
                                        )}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission
                                        feature
                                        path={routes.CREATE_DASHBOARD.path}
                                        render={(props) => (<routes.CREATE_DASHBOARD.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission
                                        feature
                                        path={routes.EDIT_DASHBOARD.path}
                                        render={(props) => (<routes.EDIT_DASHBOARD.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.bgv?.manage}
                                        feature
                                        path={routes.BGV.path}
                                        render={(props) => (<routes.BGV.component {...props} />)}
                                    />
                                    {/* <PrivateRoute 
                                        exact
                                        hasPermission={user.uiPermissions.bgv?.manage}
                                        feature
                                        path={routes.BGVDETAIL.path}
                                        render={(props) => (<routes.BGVDETAIL.component {...props} />)}
                                    /> */}
                                    <PrivateRoute
                                        exact
                                        hasPermission // TODO: Edit
                                        feature // TODO: Edit
                                        history={history}
                                        path={routes.HIRING.path}
                                        render={props => <routes.HIRING.component {...props} />}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission
                                        feature
                                        path={routes.JOB_CANDIDATE_HISTORY.path}
                                        render={(props) => (
                                            <routes.JOB_CANDIDATE_HISTORY.component
                                                {...props}
                                                entity={routes.JOB_CANDIDATE_HISTORY.entity}
                                                breadCrumb={routes.JOB_CANDIDATE_HISTORY.breadCrumb}
                                            />
                                        )}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission
                                        feature
                                        path={routes.JOB_HISTORY.path}
                                        render={(props) => (
                                            <routes.JOB_HISTORY.component
                                                {...props}
                                                entity={routes.JOB_HISTORY.entity}
                                                breadCrumb={routes.JOB_HISTORY.breadCrumb}
                                            />
                                        )}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.job?.view}
                                        feature={uiFeatures.job?.view}
                                        history={history}
                                        path={routes.JOB_LIST.path}
                                        render={props => <routes.JOB_LIST.component {...props} />}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.job?.view && user.uiPermissions.jobcandidate?.view}
                                        feature={uiFeatures.job?.view && uiFeatures.jobcandidate?.view}
                                        history={history}
                                        path={routes.JOB_VIEW.path}
                                        render={props => <routes.JOB_VIEW.component {...props} />}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.hiringevent?.view}
                                        feature={uiFeatures.hiringevent?.view}
                                        history={history}
                                        path={routes.HIRING_EVENT_LIST.path}
                                        render={props => <routes.HIRING_EVENT_LIST.component {...props} />}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.headcountplan?.view}
                                        feature={uiFeatures.headcountplan?.view}
                                        history={history}
                                        path={routes.HEAD_COUNT.path}
                                        render={props => <routes.HEAD_COUNT.component {...props} />}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.headcountplan?.add && user.uiPermissions.headcountplan?.change}
                                        feature={uiFeatures.headcountplan?.add && uiFeatures.headcountplan?.change}
                                        history={history}
                                        path={routes.HEAD_COUNT_PLAN.path}
                                        render={props => <routes.HEAD_COUNT_PLAN.component {...props} />}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.headcountplan?.view && user.uiPermissions.job?.add}
                                        feature={uiFeatures.headcountplan?.view}
                                        history={history}
                                        path={routes.REQUISITION.path}
                                        render={props => <routes.REQUISITION.component {...props} />}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.hiringevent?.add}
                                        feature={uiFeatures.hiringevent?.add}
                                        history={history}
                                        path={routes.HIRING_EVENT_CREATE.path}
                                        render={props => <routes.HIRING_EVENT_CREATE.component {...props} />}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.hiringevent?.change}
                                        feature={uiFeatures.hiringevent?.change}
                                        history={history}
                                        path={routes.HIRING_EVENT_EDIT.path}
                                        render={props => <routes.HIRING_EVENT_EDIT.component {...props} />}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.hiringpartner?.view}
                                        feature={uiFeatures.hiringpartner?.view}
                                        history={history}
                                        path={routes.HIRING_PARTNER_LIST.path}
                                        render={props => <routes.HIRING_PARTNER_LIST.component {...props} />}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.hiringpartner?.add}
                                        feature={uiFeatures.hiringpartner?.add}
                                        history={history}
                                        path={routes.HIRING_PARTNER_CREATE.path}
                                        render={props => <routes.HIRING_PARTNER_CREATE.component {...props} />}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.hiringpartner?.change}
                                        feature={uiFeatures.hiringpartner?.change}
                                        history={history}
                                        path={routes.HIRING_PARTNER_EDIT.path}
                                        render={props => <routes.HIRING_PARTNER_EDIT.component {...props} />}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.jobrole?.view}
                                        feature={uiFeatures.jobrole?.view}
                                        history={history}
                                        path={routes.JOB_ROLE_LIST.path}
                                        render={props => <routes.JOB_ROLE_LIST.component {...props} />}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.jobrole?.add}
                                        feature={uiFeatures.jobrole?.add}
                                        history={history}
                                        path={routes.JOB_ROLE_CREATE.path}
                                        render={props => <routes.JOB_ROLE_CREATE.component {...props} />}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission={user.uiPermissions.jobrole?.change}
                                        feature={uiFeatures.jobrole?.change}
                                        history={history}
                                        path={routes.JOB_ROLE_EDIT.path}
                                        render={props => <routes.JOB_ROLE_EDIT.component {...props} />}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission
                                        feature
                                        history={history}
                                        path={routes.ADD_JOB_CHART_CONFIG.path}
                                        render={props => (<routes.ADD_JOB_CHART_CONFIG.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission
                                        feature
                                        history={history}
                                        path={routes.EDIT_JOB_CHART_CONFIG.path}
                                        render={props => (<routes.EDIT_JOB_CHART_CONFIG.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission
                                        feature
                                        history={history}
                                        path={routes.ADD_EVENT_CHART_CONFIG.path}
                                        render={props => (<routes.ADD_EVENT_CHART_CONFIG.component {...props} />)}
                                    />
                                    <PrivateRoute
                                        exact
                                        hasPermission
                                        feature
                                        history={history}
                                        path={routes.EDIT_EVENT_CHART_CONFIG.path}
                                        render={props => (<routes.EDIT_EVENT_CHART_CONFIG.component {...props} />)}
                                    />
                                    <Route
                                        path="*"
                                        component={ErrorPage}
                                        user={user}
                                        history={history}
                                    />
                                </Switch>
                            </main>
                        </div>}
                    </div>
                </div>
            </>
        )
    }
}
const mapsStateToProps = (state) => ({
    processData: state.process,
});
export default connect(mapsStateToProps)(withRouter(ModularRoutes))
